export default "__VITE_ASSET__uXPL_tjD__"